import styled, { css } from 'styled-components'
import {
  Input as InputAnt,
  Select as SelectAnt,
  Modal as ModalAnt,
} from 'antd'

import { Button } from 'konsys-ui'
import { theme, media } from '../../../styles/_variables'


export const CustomSelect = styled(SelectAnt)`
  width: 100%;
  font-size: 24px;
  div.ant-select-selection {
    background-color: rgb(${theme.color.primaryColorRGB}, 0.15);
    border: 1px solid rgb(${theme.color.primaryColorRGB}, 0);
    border-radius: 8px;
  }
  div.ant-select-selection-selected-value {
    width: 100%;
    text-align: center;
  }
  span.ant-select-arrow {
    top: 40% !important;
  }
  i {
    color: ${theme.color.secondaryColor};
  }
`

export const DivToolbar = styled.div`
  margin-top: 16px;
  column-gap: 10px;
  display: flex;
  width: 100%;
  ${media.mobileXL`
    margin-top: 10px;
    display: block;
  `}
`

export const DivButtonToolbar = styled.div`
  display: flex;
  column-gap: 10px;
  ${media.mobileXL`
    padding: 10px 0px 0px 0px;
    justify-content: space-between;
  `}
`

export const ButtonToolbar = styled(Button)`
  width: max-content;
  height: initial;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-size: ${theme.fonts.size.extraNormal};
  border-radius: 25px;
  padding: 2px 8px !important;
  box-shadow: 2px 2px 0px 1px rgb(110, 201, 190, 0.4) !important;
  i {
    font-size: ${theme.fonts.size.small} !important;
    font-weight: ${theme.fonts.style.regular} !important;
  }
  ${media.laptopL`
    width: 150px;
    padding: 0px 0px !important;
  `}
  ${media.mobileXL`
    width: 100%;
  `}
  
`

export const ButtonSearch = styled(Button)`
  border-radius: 20px;
  padding: 0px 8px 0px 8px;
  margin: 6px 0px 6px 6px;
  width: auto;
  height: initial;
  display: flex;
  flex-direction: row;
  align-content: flex-start;
  align-items: center;
  i {
    font-size: ${theme.fonts.size.label} !important;
  }
  span {
    font-size: ${theme.fonts.size.small} !important;
    font-weight: ${theme.fonts.style.semiBold}
  }
  ${media.mobileL`
    width: fit-content;
    width: -moz-fit-content;
    i {
      font-size: 16px !important;
    }
  `}
`

export const InputSearch = styled(InputAnt)`
  font-size: ${theme.fonts.size.normal};
  font-wight: ${theme.fonts.style.medium};
  border: 0px;
  display: flex;
  justify-content: center;
  box-shadow: unset !important;
`

export const ImageLabel = styled.h4`
  font-weight: ${theme.fonts.style.light};
  font-size: ${theme.fonts.size.extraNormal};
  color: ${theme.color.primaryColor};
  background-color: ${theme.color.offWhite};
  text-align: center;
  padding: 4px 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  ${media.mobileS`
    font-size: ${theme.fonts.size.small}
  `}
  ${media.mobileXL`
    font-size: ${theme.fonts.size.small}
  `}
  margin-bottom: 0px !important;
`

export const ImageLabelOther = styled.h4`
  font-weight: ${theme.fonts.style.light};
  font-size: ${theme.fonts.size.extraNormal};
  color: ${theme.color.offWhite};
  background-color: ${theme.color.primaryColor};
  text-align: center;
  padding: 4px 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  ${media.mobileS`
    font-size: ${theme.fonts.size.small}
  `}
  ${media.mobileXL`
    font-size: ${theme.fonts.size.small}
  `}
  margin-bottom: 0px !important;
`

export const PackageContainer = styled.div`
  margin: 12px -8px 12px -8px;
  display: flex;
  flex-wrap: wrap;
`

export const DivPackage = styled.div`
  width: calc((100%) / 4);
  padding: 8px;
  ${media.tablet`
    width: calc((100%) / 3);
  `}
  ${media.tabletS`
    width: calc((100%) / 2);
  `}
  & {
    > div {
      -webkit-transition-duration: 400ms;
      transition-duration: 400ms;
      transition-delay: 50ms;
      filter: drop-shadow(0 2px 3px rgb(0 0 0 / 0.01)) drop-shadow(0 2px 2px rgb(0 0 0 / 0.02));
    }
  }
  &:hover {
    > div {
      transform: scale(1.02);
      transition-property: all;
      transition-duration: 400ms;
      transition-delay: 50ms;
      transition-timing-function: ease;
      filter: drop-shadow(0 20px 13px rgb(0 0 0 / 0.03)) drop-shadow(0 8px 5px rgb(0 0 0 / 0.08));
    }
  }
`

export const DivSearch = styled.div`
  display: flex;
  width: 100%;
  height: fit-content;
  height: -moz-fit-content;
  padding-right: 26px;
  background-color: ${theme.color.offWhite};
  border-radius: 25px;
  box-shadow: 2px 2px 0px 1px rgb(56, 53, 48, 0.06);
  align-items: center;
`


export const ImageWithButtonWrapper = styled.div`
  width: calc((100% - 24px) / 4);
  margin: 12px;
  text-align: center;
`

export const ImageWrapper = styled.div`
  width: 100%;
  padding-top: 100%;
  margin: 0px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
`

export const ImgBg = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  ${props => props.img && css`
    background-image: url(${props.img});
    background-size: cover;
    background-position: center;
  `}
`

export const Label = styled.h4`
  font-weight: 700;
  font-size: ${theme.fonts.size.extraNormal};
  margin: 8px 0;
  color: ${props => props.color || theme.color.primaryColor}
`

export const TagDivActive = styled(Button)`
  border-radius: 1.4rem;
  padding: 0px 12px;
  width: fit-content !important;
  max-width: 300px;
  text-align: left;
  margin: 4px;
  i {
    font-size: ${theme.fonts.size.small} !important;
    font-weight: ${theme.fonts.style.medium};
  }
  span {
    word-break: break-all;
    font-size: ${theme.fonts.size.small};
    font-weight: ${theme.fonts.style.bold};
  }
  &:hover {
    background-color: ${theme.color.paleBlack} !important;
    border-color: ${theme.color.paleBlack} !important;
  }
  ${media.tablet`
    &:hover {
      background-color: ${theme.color.primaryColor} !important;
      border-color: ${theme.color.primaryColor} !important;
    }
  `}
`

export const Modal = styled(ModalAnt)`
  .ant-modal-header {
    border-bottom: 0px !important;
    padding: 16px 24px 0px 24px !important;
  }
  
  .ant-modal-body {
    padding: 4px 24px 24px 24px !important;
  }
`

export default ImageWrapper



// WEBPACK FOOTER //
// ./src/pages/package-page/list/styled.js